export const customerPasswordRegExp = /(?=.*\d)(?=.*[A-Za-z])(?=.*[!#$%&*?@^_-])(?!.*\s).{8,}/;
export const invalidPasswordMsg = 'The password must consist of 8 characters, 1 special character, 1 capital letter and 1 number';
export const passwordsDontMatchMsg = 'The passwords don\'t match';
